import { graphColors } from "@/app/utils/constants";
import { uniqueId } from "lodash";
interface ShareHolderData {
  percentage: string;
  shareHolder: string;
}

interface ChartDataItem {
  id: string;
  data: string;
  backgroundColor: string;
  borderColor: string;
  text: string;
}

const dataFormater = ({ percentage, shareHolder }: ShareHolderData, index: number): ChartDataItem => {
  const colorIndex =
    (graphColors.length -
      1 -
      (index % graphColors.length) +
      graphColors.length) %
    graphColors.length;
  return {
    id: uniqueId(),
    data: percentage.replace("%", ""),
    backgroundColor: graphColors[colorIndex],
    borderColor: graphColors[colorIndex],
    text: shareHolder,
  };
};

export const piChartDataFormer = (dataList: ShareHolderData[]): ChartDataItem[] => {
  const formedArray: ChartDataItem[] = [];
  for (let index = 0; index < dataList.length; index++) {
    formedArray.push(dataFormater(dataList[index], index));
  }
  return formedArray;
};

interface ChartDataset {
  labels: string;
  data: number[];
  backgroundColor: string[];
  borderColor: string[];
  text: string[];
  hoverOffset: number;
  borderWidth: number;
}

const generateChartData = (dataList: ChartDataItem[]): { datasets: ChartDataset[] } => {
  return {
    datasets: [
      {
        labels: "Pi Chart",
        data: dataList.map((e) => Number(e.data)),
        backgroundColor: dataList.map((e) => e.backgroundColor),
        borderColor: dataList.map((e) => e.borderColor),
        text: dataList.map((e) => e.text),
        hoverOffset: 4,
        borderWidth: 1,
      },
    ],
  };
};

export default generateChartData;
